//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';

import DJAreaSideMenu from './sidemenu';
import moment from 'moment';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/adminlte.css';
import './css/competition.css';

export default class DJAreaCompetition extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			prev: [],
			current: []

		};
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		const params = new URLSearchParams();
		const x = await postApi('/api/v2/djarea/competition', params);
		console.log(x.data);
		this.setState({status: true, prev: x.data.prev, current: x.data.current});
	}

	componentWillUnmount() {
	}

	render() {
		const current = Object.keys(this.state.current).map((e,i) => {
			return (
				<Row key={i}>
					<div style={{width: 70, textAlign: 'center'}}>
						#{i+1}
					</div>
					
					<Col>{this.state.current[i].title?this.state.current[i].title:this.state.current[i].username}</Col>
					<Col style={{color: '#F0E68C'}}>{this.state.current[i].lph}</Col>
					<Col>{this.state.current[i].sets}</Col>
					<Col>{Math.floor(this.state.current[i].length/3600)}</Col>
					<Col>{this.state.current[i].likes}</Col>
					
				</Row>
			)
		})
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				{this.state.status &&
					<Col>
					
						<div className="card bg-dark">
							<div className="card-header">
								<h3 className="card-title">DJ Competition</h3>
							</div>
							<div className="card-body">
								Content of the running dj competition
							</div>
						</div>
						
						<div className="card bg-dark">
							<div className="card-header">
								<h3 className="card-title">Current running month - {moment(this.state.current[1].ctime*1000).format('MMMM YYYY')}</h3>
							</div>
							<div className="card-body">
								<Row>
									<div style={{width: 70, textAlign: 'center'}}>
									</div>
									<Col>DJ Name</Col>
									<Col style={{color: '#F0E68C'}}>Likes Per Hour</Col>
									<Col>Performances</Col>
									<Col>Hours Played</Col>
									<Col>Likes</Col>
									
								</Row>
								{current}
							</div>
						</div>

						{this.state.prev[0] &&
							<div className="card bg-dark">
								<div className="card-header">
									<h3 className="card-title">Winners from {moment(this.state.prev[1].ctime*1000).format('MMMM YYYY')}</h3>
								</div>
								<div className="card-body">
									<Row>
										<Col xs={4}>
											{this.state.prev[1] &&
												<div className="trophy-silver">
													<img src="/images/trophy-silver.png" />
													<div className="trophy-silver-avatar">
														<img src={`https://mix365.co.uk${this.state.prev[1].avatar}`} />
														<div className="trophy-silver-name">{this.state.prev[1].title?this.state.prev[1].title:this.state.prev[1].username}</div>
													</div>
													<div className="trophy-silver-likes">
														<div className="trophy-silver-likes-text">
															{this.state.prev[1].likes}
														</div>
													</div>
												</div>
											}
										</Col>
										<Col xs={12} md={4}>
											{this.state.prev[0] &&
												<div className="trophy-gold">
													<img src="/images/trophy-gold.png" />
													<div className="trophy-gold-avatar">
														<img src={`https://mix365.co.uk${this.state.prev[0].avatar}`} />
														<div className="trophy-gold-name">{this.state.prev[0].title?this.state.prev[0].title:this.state.prev[0].username}</div>
													</div>
													<div className="trophy-gold-likes">
														<div className="trophy-gold-likes-text">
															{this.state.prev[0].likes}
														</div>
													</div>
												</div>
											}
											{/*(() => {
												this.state.prev[0] 
											})()*/}
										</Col>
										<Col xs={4}>
											{this.state.prev[2] &&
												<div className="trophy-bronze">
													<img src="/images/trophy-bronze.png" />
													<div className="trophy-bronze-avatar">
														<img src={`https://mix365.co.uk${this.state.prev[2].avatar}`} />
														<div className="trophy-bronze-name">{this.state.prev[2].title?this.state.prev[2].title:this.state.prev[2].username}</div>
													</div>
													<div className="trophy-bronze-likes">
														<div className="trophy-bronze-likes-text">
															{this.state.prev[2].likes}
														</div>
													</div>
												</div>
											}
										</Col>
									</Row>
								</div>
							</div>
						}

					</Col>
				}
			</Row>
		);
	}
}
